// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thank-you-section-wrapper-psp {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin-top: 130px;
  padding: 0 18px;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp span {
  text-align: center;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp > span:first-child {
  font-family: "Playfair Display", serif !important;
  font-size: 32px;
  font-weight: 700;
  color: #12C53F;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp.failure > span:first-child {
  color: #e34444;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp > span:nth-child(2) {
  font-size: 22px;
  font-weight: 700;
  color: #000;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp > span:nth-child(3) {
  font-size: 18px;
  font-weight: 500;
  color: #000;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 10px;
}
.thank-you-section-wrapper-psp .thank-you-section-body-wrapper-psp > div button {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #93288E;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  padding: 14px 18px;
  cursor: pointer;
  width: 250px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PaymentStatusPage/components/ThankYouSectionPSP/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACI,kBAAA;AACZ;AAEQ;EACI,iDAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAZ;AAIY;EACI,cAAA;AAFhB;AAMQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAJZ;AAOQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AALZ;AAQQ;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AANZ;AAQY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AANhB","sourcesContent":[".thank-you-section-wrapper-psp{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n    margin-top: 130px;\n    padding: 0 18px;\n    \n    .thank-you-section-body-wrapper-psp{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 14px;\n        \n        span{\n            text-align: center;\n        }\n\n        >span:first-child{\n            font-family: \"Playfair Display\", serif !important;\n            font-size: 32px;\n            font-weight: 700;\n            color: #12C53F;\n            }\n\n        &.failure{\n            >span:first-child{\n                color: #e34444;\n            }\n        }\n\n        >span:nth-child(2){\n            font-size: 22px;\n            font-weight: 700; \n            color: #000;   \n        }\n\n        >span:nth-child(3){\n            font-size: 18px;\n            font-weight: 500; \n            color: #000;\n        }\n\n        >div{\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: center;\n            gap: 20px;\n            margin-top: 10px;\n            \n            button{\n                display: flex;\n                align-items: center;\n                gap: 12px;\n                font-size: 18px;\n                font-weight: 600;\n                color: #93288E;\n                border: 1px solid #E8E8E8;\n                border-radius: 5px;\n                padding: 14px 18px; \n                cursor: pointer;\n                width: 250px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
